import { render, staticRenderFns } from "./AccountSettingDocument.vue?vue&type=template&id=df740d96&"
import script from "./AccountSettingDocument.vue?vue&type=script&lang=js&"
export * from "./AccountSettingDocument.vue?vue&type=script&lang=js&"
import style0 from "./AccountSettingDocument.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports